import { render, staticRenderFns } from "./aiReportBI.vue?vue&type=template&id=a6069ee0&scoped=true"
import script from "./aiReportBI.vue?vue&type=script&lang=js"
export * from "./aiReportBI.vue?vue&type=script&lang=js"
import style0 from "./aiReportBI.vue?vue&type=style&index=0&id=a6069ee0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6069ee0",
  null
  
)

export default component.exports